module.exports = __webpack_public_path__ + "static/enders-game-3d3fe19408217f870f6a55a8389fb86c.jpg";